var _defs;
import * as React from "react";
import { forwardRef } from "react";
const SvgDefinitions = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ct-link-arrow",
    strokeLinecap: "round",
    d: "M5,0 0,2.5 5,5 3.5,3 3.5,2z"
  }), /*#__PURE__*/React.createElement("marker", {
    id: "ct-link-arrow-marker",
    markerHeight: 5,
    markerWidth: 5,
    orient: "auto",
    refX: 2.5,
    refY: 2.5
  }, /*#__PURE__*/React.createElement("use", {
    href: "#ct-link-arrow",
    strokeWidth: 1,
    transform: "rotate(180 2.5 2.5) scale(1,1)"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "ct-link-arrow-marker-hover",
    markerHeight: 5,
    markerWidth: 5,
    orient: "auto",
    refX: 2.5,
    refY: 2.5
  }, /*#__PURE__*/React.createElement("use", {
    href: "#ct-link-arrow",
    strokeWidth: 1,
    transform: "rotate(180 2.5 2.5) scale(1,1)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "hatching",
    width: 6,
    height: 10,
    patternUnits: "userSpaceOnUse",
    patternTransform: "rotate(20 50 50)"
  }), /*#__PURE__*/React.createElement("pattern", {
    id: "disconnected",
    href: "#hatching"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 10
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: "5px",
    y2: 10
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "incomplete",
    href: "#hatching"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 10
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: "5px",
    y2: 10
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDefinitions);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/definitions.38ce98aa64e31feda8d57d9f8a1b964c.svg";